module.exports = __webpack_public_path__ + "static/media/full_logo_ligth.f35457ab.svg";